import React from 'react'
import { useParams } from 'react-router-dom'
import PageNotFound from 'routes/PageNotFound/PageNotFound'

import CustomCorporateActionPage from './CustomCorporateActionPage'
import { DividendsNavigation, DividendsTab } from './DividendsNavigation'
import DividendsPage from './DividendsPage'
import SystemCorporateActionPage from './SystemCorporateActionPage'

const ResolveDividendsRoute = (): JSX.Element => {
  const { slug } = useParams<{ slug: DividendsTab }>()

  const matchesSlug = (slub?: DividendsTab) => {
    if (!slub) {
      return false
    }
    return (
      slub === DividendsTab.CustomDividends ||
      slub === DividendsTab.SystemCorporate ||
      slub === DividendsTab.CustomCorporate
    )
  }

  const innerRender = () => {
    if (!matchesSlug(slug)) {
      return <PageNotFound />
    }
    if (slug === DividendsTab.CustomDividends) {
      return (
        <React.Fragment>
          <DividendsNavigation tab={DividendsTab.CustomDividends} />
          <DividendsPage />
        </React.Fragment>
      )
    }
    if (slug === DividendsTab.CustomCorporate) {
      return (
        <React.Fragment>
          <DividendsNavigation tab={DividendsTab.CustomCorporate} />
          <CustomCorporateActionPage />
        </React.Fragment>
      )
    }
    if (slug === DividendsTab.SystemCorporate) {
      return (
        <React.Fragment>
          <DividendsNavigation tab={DividendsTab.SystemCorporate} />
          <SystemCorporateActionPage />
        </React.Fragment>
      )
    }
    return <PageNotFound />
  }
  return innerRender()
}

export default ResolveDividendsRoute
